import * as React from 'react'

function IconRoundedRectangleCanJoin({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={142}
      viewBox="0 0 104 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#filter1_rounded)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M103 17.04v107.425h-.079c-5.1 0-9.893 2.183-13.458 5.831-5.845 5.975-20.415 10.214-37.465 10.214-17.046 0-31.62-4.235-37.466-10.214-3.564-3.644-8.357-5.826-13.458-5.826H1V17.04h.074c5.096 0 9.894-2.183 13.458-5.826C20.377 5.239 34.952 1 51.998 1c17.05 0 31.62 4.234 37.465 10.21 3.565 3.643 8.358 5.83 13.458 5.83H103z"
              fill="#fff"
              stroke={color}
              strokeWidth={2}
            />
            <path
              d="M51.998 131.297c-17.206 0-28.073-4.554-30.88-7.425-3.149-3.22-6.87-5.602-10.905-7.042V24.68c4.034-1.44 7.752-3.822 10.904-7.043 2.808-2.87 13.68-7.424 30.88-7.424 17.201 0 28.073 4.553 30.881 7.424 3.153 3.22 6.875 5.602 10.91 7.043v92.15c-4.035 1.44-7.757 3.822-10.91 7.042-2.808 2.871-13.675 7.425-30.88 7.425z"
              fill={color}
              stroke="#fff"
            />
          </g>
          <defs>
            <filter
              id="filter1_rounded"
              x={0}
              y={0}
              width={104}
              height={141.51}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M103 17.04v107.425h-.079c-5.1 0-9.893 2.183-13.458 5.831-5.845 5.975-20.415 10.214-37.465 10.214-17.046 0-31.62-4.235-37.466-10.214-3.564-3.644-8.357-5.826-13.458-5.826H1V17.04h.074c5.096 0 9.894-2.183 13.458-5.826C20.377 5.239 34.952 1 51.998 1c17.05 0 31.62 4.234 37.465 10.21 3.565 3.643 8.358 5.83 13.458 5.83H103z"
            fill="#fff"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M51.998 131.297c-17.206 0-28.073-4.554-30.88-7.425-3.149-3.22-6.87-5.602-10.905-7.042V24.68c4.034-1.44 7.752-3.822 10.904-7.043 2.808-2.87 13.68-7.424 30.88-7.424 17.201 0 28.073 4.553 30.881 7.424 3.153 3.22 6.875 5.602 10.91 7.043v92.15c-4.035 1.44-7.757 3.822-10.91 7.042-2.808 2.871-13.675 7.425-30.88 7.425z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRoundedRectangleCanJoin
